export const facetSortCriteria = [
    'score',
    'alphanumeric',
    'alphanumericDescending',
    'occurrences',
    'automatic',
    'alphanumericNatural',
    'alphanumericNaturalDescending',
];
